<div class="dashboard-container" [class.full-screen-mode]="enableFullScreenMode && !isPatientOutletActive()">
    <div class="left-content" *ngIf="showList" [class.full-screen]="hideRight" [class.has-border]="!isMobile && !hideRight">
        <router-outlet></router-outlet>
    </div>
    <div class="right-content" *ngIf="showPatient">
        <router-outlet name="patient"></router-outlet>
    </div>
</div>